import * as React from "react";
import { Modal, Button } from "semantic-ui-react";

interface ModalProps {
	title: string;
	content: string;
	isOpen: boolean;
	onClose: () => void;
}

const WrappedModal: React.SFC<ModalProps> = props => (
	<Modal
		// closeIcon
		closeOnEscape={true}
		open={props.isOpen}
		onClose={props.onClose}
		// content={props.content}
		closeOnDimmerClick={true}
		// closeOnDocumentClick
		// defaultOpen={false}
	>
		<Modal.Header>
			<div
				style={{
					display: "flex",
					flexDirection: "row",
					justifyContent: "space-between",
					alignItems: "center",
					width: "100%"
				}}
			>
				<p style={{ margin: 0 }}>{props.title}</p>
				<Button icon="close" onClick={props.onClose} />
			</div>
		</Modal.Header>
		<Modal.Content>{props.content}</Modal.Content>
	</Modal>
);

export default WrappedModal;



// WEBPACK FOOTER //
// ./src/components/WrappedModal/WrappedModal.tsx